import React, { useEffect, useState } from "react";
import {
  CircularProgress,
  Grid,
  Input,
  makeStyles,
  Typography,
} from "@material-ui/core";
import { useFormik } from "formik";
import { FormattedMessage, useIntl } from "react-intl";
import { InputField } from "../../../../../components/input-field/InputField";
import * as Yup from "yup";
import { InputButton } from "../../../../../components/input-button/InputButton";
import { Alert } from "@material-ui/lab";
import { read, utils, writeFile } from "xlsx";
import RaffleDrawService from "../../../../../services/RaffleDrawService";
import { Empty } from "antd";

const useStyles = makeStyles((theme) => ({
  titre: {
    textAlign: "center",
    margin: 35,
  },
  subTitre: {
    margin: 20,
  },
  blockFile: {
    margin: 25,
  },
  fieldAndButton: {
    margin: 35,
    width: 500,
  },
  view: {
    textAlign: "center",
  },
  loadBtn: {
    width: 150,
  },
  data: {
    margin: 35,
  },
  inputGrid: {
    padding: 5,
  },
  telephoneGrig: {
    display: "inline-block",
    padding: 5,
  },
  rightInputGrid: {
    padding: 5,
    textAlign: "right",
  },
  rightInputBtn: {
    padding: 5,
    width: 150,
  },
}));

interface ImportExcelFileProps {}

export const ImportExcelFile = () => {
  const { formatMessage } = useIntl();
  const classes = useStyles();
  const intl = useIntl();

  const [excelData, setExcelData] = useState(null);
  const [excelFile, setExcelFile] = useState(null);
  const [excelFileError, setExcelFileError] = useState(null);
  const [phoneNumbers, setPhoneNumbers] = useState([]);
  const [importResult, setImportResult] = useState([]);
  const [loadingBtn, setLoadingBtn] = useState(false);
  const [loadingImportBtn, setLoadingImportBtn] = useState(false);
  const [showImportMessage, setShowImportMessage] = useState(false);

  //hanle File Excel
  const fileType = [
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    "application/vnd.ms-excel",
  ];
  const handleFile = (e) => {
    let selectedFile = (e.target as HTMLInputElement).files[0];
    if (selectedFile) {
      //console.log(selectedFile.type);
      if (selectedFile && fileType.includes(selectedFile.type)) {
        let reader = new FileReader();
        reader.readAsArrayBuffer(selectedFile);
        reader.onload = (e) => {
          setExcelFileError(null);
          setExcelFile(e.target.result);
        };
      } else {
        setExcelFileError("Please select only excel file types");
        setExcelFile(null);
      }
    } else {
      console.log("Please select your file");
    }
  };

  const sendPhoneNumbers = () => {
    setLoadingBtn(true);
    RaffleDrawService.importPhoneNumbers(phoneNumbers).then((response) => {
      const resultData = JSON.parse(JSON.stringify(response.data));
      setImportResult(resultData.data);
      setLoadingBtn(false);

      let unregisteredNumbers = [];
      resultData.data["un_registered"].forEach((unregisteredNumber) => {
        let phoneNumber = {};
        phoneNumber["telephone"] = unregisteredNumber;
        unregisteredNumbers.push(phoneNumber);
      });

      setPhoneNumbers(unregisteredNumbers);
      setShowImportMessage(true);
      setTimeout(() => {
        setShowImportMessage(false);
      }, 10000);
    });
  };

  //Submit function
  const handleSubmit = (e) => {
    setLoadingImportBtn(true);
    let data: any[];
    e.preventDefault();
    if (excelFile !== null) {
      const workBook = read(excelFile, { type: "buffer" });
      const workSheetName = workBook.SheetNames[0];
      const workSheet = workBook.Sheets[workSheetName];
      //const data = utils.sheet_to_json(workSheet);
      data = utils.sheet_to_json(workSheet, {
        header: 1,
        blankrows: false,
      });
      //console.log(data);

      setExcelData(data);
      let currentPhoneNumbers = [...phoneNumbers];
      /*if(currentPhoneNumbers[phoneNumbers.length - 1].telephone === ""){
        currentPhoneNumbers.pop();
      }*/

      for (let index: number = 3; index < data.length; index++) {
        if (data[index].length === 2) {
          let insertNumber = data[index][1].toString();
          if (
            currentPhoneNumbers[currentPhoneNumbers.length - 1].telephone === ""
          ) {
            currentPhoneNumbers.pop();
          }
          console.log(typeof insertNumber);

          if (insertNumber.length === 9) {
            insertNumber = "+237" + insertNumber;
          }

          if (insertNumber[0] !== "+") {
            insertNumber = "+" + insertNumber;
          }

          let phoneNumber = {};
          phoneNumber["telephone"] = insertNumber;
          currentPhoneNumbers.push(phoneNumber);
        }
      }
      console.log(currentPhoneNumbers);
      //let totalPhoneNumbers = [...currentPhoneNumbers,...data];
      setPhoneNumbers(currentPhoneNumbers);
      setLoadingImportBtn(false);
      setExcelFile(null);
    } else {
      setExcelData(null);
      setLoadingImportBtn(false);
    }
  };

  const handleChangeOfTelephone = (index: number, telephone: string) => {
    let currentPhoneNumbers = [...phoneNumbers];
    let tmpPhoneNumber = {};
    tmpPhoneNumber["telephone"] = telephone;
    currentPhoneNumbers[index] = tmpPhoneNumber;
    console.log(currentPhoneNumbers);
    setPhoneNumbers(currentPhoneNumbers);
  };

  const addPhoneNumber = () => {
    //let numberOfPackages = packageWinnersInfos.length;
    let currentPhoneNumbers = [...phoneNumbers];
    let phoneNumber = {};
    phoneNumber["telephone"] = "";
    if (currentPhoneNumbers[phoneNumbers.length - 1].telephone === "") {
      alert(
        intl.formatMessage({
          id: "sharedScreen.pleaseFillTheLastField",
        })
      );
    } else {
      currentPhoneNumbers.push(phoneNumber);
      setPhoneNumbers(currentPhoneNumbers);
    }
  };

  const loadfirstBox = () => {
    let phoneNumberObj = {};
    phoneNumberObj["telephone"] = "";

    setPhoneNumbers([phoneNumberObj]);
  };

  useEffect(() => {
    loadfirstBox();
  }, []);

  return (
    <>
      <Grid className={classes.titre} xs={12} sm={12} lg={12}>
        <Typography variant="h2" component="h2">
          <FormattedMessage id="sharedScreen.dataCollectionFile" />
        </Typography>
      </Grid>
      <Grid item xs={12} sm={12} lg={12}>
        <Grid item xs={6} sm={6} lg={12} className={classes.blockFile}>
          <form noValidate onSubmit={handleSubmit} autoComplete="off">
            <Typography variant="h4" component="h4">
              <FormattedMessage id="sharedScreen.uploadFile" />
            </Typography>
            <Input
              type="file"
              name="file"
              required
              onChange={handleFile}
              className={classes.fieldAndButton}
            />
            {excelFileError && (
              <Alert severity="success">{excelFileError}</Alert>
            )}
            {!loadingImportBtn ? (
              <InputButton
                className={classes.loadBtn}
                type="submit"
                variant="contained"
                color="secondary"
              >
                <FormattedMessage id="sharedScreen.importValidate" />
              </InputButton>
            ) : (
              <CircularProgress />
            )}
          </form>
        </Grid>
        <hr />
        <Grid item xs={12} sm={12} lg={12} className={classes.view}>
          <Typography variant="h2" component="h2">
            <FormattedMessage id="sharedScreen.viewExcelData" />
          </Typography>
        </Grid>
        {showImportMessage && (
          <Grid item xs={12} sm={12} lg={12}>
            {(importResult["registered"].length > 0 ||
              importResult["already_exist"].length > 0) && (
              <Alert severity="success">
                <FormattedMessage
                  id="sharedScreen.importParticipantMessage"
                  values={{
                    registered: importResult["registered"].length,
                    exist_participant: importResult["already_exist"].length,
                  }}
                />
              </Alert>
            )}
            <br />
            {importResult["un_registered"].length > 0 && (
              <Alert severity="error">
                <FormattedMessage
                  id="sharedScreen.unregisteredParticipantsMessage"
                  values={{
                    unregistered: importResult["un_registered"].length,
                  }}
                />
              </Alert>
            )}
          </Grid>
        )}
        <Grid item xs={6} sm={3} lg={12} className={classes.data}>
          <>
            {phoneNumbers.map((row, index) => {
              return (
                <>
                  <Grid
                    container
                    className={classes.telephoneGrig}
                    item
                    xs={12}
                    sm={6}
                    lg={4}
                  >
                    <InputField
                      value={phoneNumbers[index].telephone}
                      type="text"
                      fullWidth
                      placeholder={
                        formatMessage({
                          id: "sharedScreen.phoneNumber",
                        }) +
                        " " +
                        (index + 1)
                      }
                      label={
                        formatMessage({
                          id: "sharedScreen.phoneNumber",
                        }) +
                        " " +
                        (index + 1)
                      }
                      name="phone_number"
                      onChange={(event) =>
                        handleChangeOfTelephone(index, event.target.value)
                      }
                    />
                  </Grid>
                </>
              );
            })}

            <Grid item xs={6} sm={6} lg={1}>
              <InputButton
                type="submit"
                fullWidth
                variant="contained"
                color="secondary"
                onClick={(event) => addPhoneNumber()}
              >
                <FormattedMessage id="sharedScreen.addPhone" />
              </InputButton>
            </Grid>

            <br />
            <hr />
            <Grid
              className={classes.rightInputGrid}
              item
              xs={3}
              sm={12}
              lg={12}
              alignContent="flex-end"
            >
              {!loadingBtn ? (
                <InputButton
                  type="submit"
                  variant="contained"
                  color="secondary"
                  onClick={sendPhoneNumbers}
                  className={classes.rightInputBtn}
                >
                  <FormattedMessage id="sharedScreen.validate" />
                </InputButton>
              ) : (
                <CircularProgress />
              )}
            </Grid>
          </>
        </Grid>
      </Grid>
    </>
  );
};

export default ImportExcelFile;
